<template>
  <div>
    <base-input
      class="password-input"
      v-bind="$attrs"      
      v-on="$listeners"
      :type="isPasswordVisible ? 'text' : 'password' "
      :append-icon="isPasswordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"
      @append-click="showVisibility"
      :label="label"
      :placeholder="placeholder"
      :basrules="rules"
      :name="name"
      :wrapper-class="wrapperClass"
      :input-classes="inputClasses"
      :input-style="inputStyle"
      >
    </base-input>
  </div>
</template>

<script>
import BaseInput from './BaseInput.vue';

export default {
  components: { BaseInput },
  name: 'PasswordInput',
  props: {
    label: { type: String, default: 'Senha' },
    placeholder: { type: String, default: '' },
    name: { type: String, default: 'password' },
    rules: { type: [String, Array, Object], default: '' },
    required: { type: Boolean, default: true },
    wrapperClass: { type: [String, Object], default: 'form-group' },
    inputClasses: { type: String, default: '' },
    inputStyle: { type: String, default: '' },
},
  data() {
    return {
      isPasswordVisible: false,
    };
  },
  methods: {
    showVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>

<style>
</style>